export default __webpack_public_path__ + "static/media/12-month-plan-illustration.69374f32.svg";